!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports.ReactCrop = t(require("react")) : e.ReactCrop = t(e.React);
}(this, function (e) {
  return function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        r.d(n, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 4);
  }([function (e, t, r) {
    e.exports = r(2)();
  }, function (t, r) {
    t.exports = e;
  }, function (e, t, r) {
    "use strict";

    var n = r(3);

    function o() {}

    function i() {}

    i.resetWarningCache = o, e.exports = function () {
      function e(e, t, r, o, i, a) {
        if (a !== n) {
          var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw c.name = "Invariant Violation", c;
        }
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var r = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        elementType: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: i,
        resetWarningCache: o
      };
      return r.PropTypes = r, r;
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, r) {
    "use strict";

    r.r(t), r.d(t, "default", function () {
      return M;
    }), r.d(t, "Component", function () {
      return M;
    }), r.d(t, "makeAspectCrop", function () {
      return R;
    }), r.d(t, "containCrop", function () {
      return k;
    });
    var n = r(1),
        o = r.n(n),
        i = r(0),
        a = r.n(i);

    function c(e) {
      var t,
          r,
          n = "";
      if ("string" == typeof e || "number" == typeof e) n += e;else if ("object" == typeof e) if (Array.isArray(e)) for (t = 0; t < e.length; t++) {
        e[t] && (r = c(e[t])) && (n && (n += " "), n += r);
      } else for (t in e) {
        e[t] && (n && (n += " "), n += t);
      }
      return n;
    }

    function s(e) {
      return (s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function d(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function u(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    function p(e, t) {
      return (p = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function h(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = m(e);

        if (t) {
          var o = m(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return f(this, r);
      };
    }

    function f(e, t) {
      return !t || "object" !== s(t) && "function" != typeof t ? l(e) : t;
    }

    function l(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function m(e) {
      return (m = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function v(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function y(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? v(Object(r), !0).forEach(function (t) {
          g(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : v(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function g(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function w(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
        var r = [],
            n = !0,
            o = !1,
            i = void 0;

        try {
          for (var a, c = e[Symbol.iterator](); !(n = (a = c.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0) {
            ;
          }
        } catch (e) {
          o = !0, i = e;
        } finally {
          try {
            n || null == c.return || c.return();
          } finally {
            if (o) throw i;
          }
        }

        return r;
      }(e, t) || function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return C(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === r && e.constructor && (r = e.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(e);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return C(e, t);
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function C(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = new Array(t); r < t; r++) {
        n[r] = e[r];
      }

      return n;
    }

    var b = !1;

    try {
      window.addEventListener("test", null, Object.defineProperty({}, "passive", {
        get: function get() {
          return b = !0, !0;
        }
      }));
    } catch (e) {}

    function O(e) {
      var t, r;

      if (e.touches) {
        var n = w(e.touches, 1)[0];
        t = n.pageX, r = n.pageY;
      } else t = e.pageX, r = e.pageY;

      return {
        x: t,
        y: r
      };
    }

    function x(e, t, r) {
      return Math.min(Math.max(e, t), r);
    }

    function D(e) {
      return e && !isNaN(e.width) && !isNaN(e.height);
    }

    function S(e) {
      return "n" === e ? "s" : "ne" === e ? "sw" : "e" === e ? "w" : "se" === e ? "nw" : "s" === e ? "n" : "sw" === e ? "ne" : "w" === e ? "e" : "nw" === e ? "se" : e;
    }

    function R(e, t, r) {
      if (isNaN(e.aspect)) return console.warn("`crop.aspect` should be a number in order to make an aspect crop", e), e;
      var n = y({
        unit: "px",
        x: 0,
        y: 0
      }, e);
      return e.width && (n.height = n.width / e.aspect), e.height && (n.width = n.height * e.aspect), n.y + n.height > r && (n.height = r - n.y, n.width = n.height * e.aspect), n.x + n.width > t && (n.width = t - n.x, n.height = n.width / e.aspect), n;
    }

    function E(e, t, r) {
      return "%" === e.unit ? e : {
        unit: "%",
        aspect: e.aspect,
        x: e.x / t * 100,
        y: e.y / r * 100,
        width: e.width / t * 100,
        height: e.height / r * 100
      };
    }

    function _(e, t, r) {
      return e.unit ? "px" === e.unit ? e : {
        unit: "px",
        aspect: e.aspect,
        x: e.x * t / 100,
        y: e.y * r / 100,
        width: e.width * t / 100,
        height: e.height * r / 100
      } : y(y({}, e), {}, {
        unit: "px"
      });
    }

    function k(e, t, r, n) {
      var o = _(t, r, n),
          i = _(e, r, n),
          a = y({}, o);

      if (!o.aspect) return o.x < 0 ? (a.x = 0, a.width += o.x) : o.x + o.width > r && (a.width = r - o.x), o.y + o.height > n && (a.height = n - o.y), a;
      var c = !1;
      o.x < 0 ? (a.x = 0, a.width += o.x, a.height = a.width / o.aspect, c = !0) : o.x + o.width > r && (a.width = r - o.x, a.height = a.width / o.aspect, c = !0), c && i.y > a.y && (a.y = o.y + (o.height - a.height));
      var s = !1;
      return a.y + a.height > n && (a.height = n - o.y, a.width = a.height * o.aspect, s = !0), s && i.x > a.x && (a.x = o.x + (o.width - a.width)), a;
    }

    var M = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && p(e, t);
      }(a, e);
      var t,
          r,
          n,
          i = h(a);

      function a() {
        var e;
        d(this, a);

        for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) {
          r[n] = arguments[n];
        }

        return g(l(e = i.call.apply(i, [this].concat(r))), "window", "undefined" != typeof window ? window : {}), g(l(e), "document", "undefined" != typeof document ? document : {}), g(l(e), "state", {}), g(l(e), "keysDown", new Set()), g(l(e), "onCropMouseTouchDown", function (t) {
          var r = e.props,
              n = r.crop,
              o = r.disabled,
              i = e.mediaDimensions,
              a = _(n, i.width, i.height);

          if (!o) {
            t.preventDefault();
            var c = O(t);
            e.componentRef.setActive ? e.componentRef.setActive({
              preventScroll: !0
            }) : e.componentRef.focus({
              preventScroll: !0
            });
            var s,
                d = t.target.dataset.ord,
                u = "nw" === d || "w" === d || "sw" === d,
                p = "nw" === d || "n" === d || "ne" === d;
            a.aspect && (s = e.getElementOffset(e.cropSelectRef)), e.evData = {
              clientStartX: c.x,
              clientStartY: c.y,
              cropStartWidth: a.width,
              cropStartHeight: a.height,
              cropStartX: u ? a.x + a.width : a.x,
              cropStartY: p ? a.y + a.height : a.y,
              xInversed: u,
              yInversed: p,
              xCrossOver: u,
              yCrossOver: p,
              startXCrossOver: u,
              startYCrossOver: p,
              isResize: t.target.dataset.ord,
              ord: d,
              cropOffset: s
            }, e.mouseDownOnCrop = !0, e.setState({
              cropIsActive: !0
            });
          }
        }), g(l(e), "onComponentMouseTouchDown", function (t) {
          var r = e.props,
              n = r.crop,
              o = r.disabled,
              i = r.locked,
              a = r.keepSelection,
              c = r.onChange,
              s = e.mediaWrapperRef.firstChild;

          if (t.target === s && s.contains(t.target) && !(o || i || a && D(n))) {
            t.preventDefault();
            var d = O(t);
            e.componentRef.setActive ? e.componentRef.setActive({
              preventScroll: !0
            }) : e.componentRef.focus({
              preventScroll: !0
            });
            var u = e.getElementOffset(e.mediaWrapperRef),
                p = d.x - u.left,
                h = d.y - u.top,
                f = {
              unit: "px",
              aspect: n ? n.aspect : void 0,
              x: p,
              y: h,
              width: 0,
              height: 0
            };
            e.evData = {
              clientStartX: d.x,
              clientStartY: d.y,
              cropStartWidth: f.width,
              cropStartHeight: f.height,
              cropStartX: f.x,
              cropStartY: f.y,
              xInversed: !1,
              yInversed: !1,
              xCrossOver: !1,
              yCrossOver: !1,
              startXCrossOver: !1,
              startYCrossOver: !1,
              isResize: !0,
              ord: "nw"
            }, e.mouseDownOnCrop = !0;
            var l = e.mediaDimensions,
                m = l.width,
                v = l.height;
            c(_(f, m, v), E(f, m, v)), e.setState({
              cropIsActive: !0,
              newCropIsBeingDrawn: !0
            });
          }
        }), g(l(e), "onDocMouseTouchMove", function (t) {
          var r = e.props,
              n = r.crop,
              o = r.disabled,
              i = r.onChange,
              a = r.onDragStart;

          if (!o && e.mouseDownOnCrop) {
            t.preventDefault(), e.dragStarted || (e.dragStarted = !0, a(t));
            var c,
                s = l(e).evData,
                d = O(t);

            if (s.isResize && n.aspect && s.cropOffset && (d.y = e.straightenYPath(d.x)), s.xDiff = d.x - s.clientStartX, s.yDiff = d.y - s.clientStartY, (c = s.isResize ? e.resizeCrop() : e.dragCrop()) !== n) {
              var u = e.mediaDimensions,
                  p = u.width,
                  h = u.height;
              i(_(c, p, h), E(c, p, h));
            }
          }
        }), g(l(e), "onComponentKeyDown", function (t) {
          var r = e.props,
              n = r.crop,
              o = r.disabled,
              i = r.onChange,
              c = r.onComplete;

          if (!o) {
            e.keysDown.add(t.key);
            var s = !1;

            if (D(n)) {
              var d = e.makeNewCrop(),
                  u = (navigator.platform.match("Mac") ? t.metaKey : t.ctrlKey) ? a.nudgeStepLarge : t.shiftKey ? a.nudgeStepMedium : a.nudgeStep;

              if (e.keysDown.has("ArrowLeft") && (d.x -= u, s = !0), e.keysDown.has("ArrowRight") && (d.x += u, s = !0), e.keysDown.has("ArrowUp") && (d.y -= u, s = !0), e.keysDown.has("ArrowDown") && (d.y += u, s = !0), s) {
                t.preventDefault();
                var p = e.mediaDimensions,
                    h = p.width,
                    f = p.height;
                d.x = x(d.x, 0, h - d.width), d.y = x(d.y, 0, f - d.height);

                var l = _(d, h, f),
                    m = E(d, h, f);

                i(l, m), c(l, m);
              }
            }
          }
        }), g(l(e), "onComponentKeyUp", function (t) {
          e.keysDown.delete(t.key);
        }), g(l(e), "onDocMouseTouchEnd", function (t) {
          var r = e.props,
              n = r.crop,
              o = r.disabled,
              i = r.onComplete,
              a = r.onDragEnd;

          if (!o && e.mouseDownOnCrop) {
            e.mouseDownOnCrop = !1, e.dragStarted = !1;
            var c = e.mediaDimensions,
                s = c.width,
                d = c.height;
            a(t), i(_(n, s, d), E(n, s, d)), e.setState({
              cropIsActive: !1,
              newCropIsBeingDrawn: !1
            });
          }
        }), g(l(e), "onMediaLoaded", function () {
          var t = e.props,
              r = t.onComplete,
              n = t.onChange,
              o = e.createNewCrop(),
              i = o.pixelCrop,
              a = o.percentCrop;
          n(i, a), r(i, a);
        }), e;
      }

      return t = a, (r = [{
        key: "componentDidMount",
        value: function value() {
          if (this.document.addEventListener) {
            var e = !!b && {
              passive: !1
            };
            this.document.addEventListener("mousemove", this.onDocMouseTouchMove, e), this.document.addEventListener("touchmove", this.onDocMouseTouchMove, e), this.document.addEventListener("mouseup", this.onDocMouseTouchEnd, e), this.document.addEventListener("touchend", this.onDocMouseTouchEnd, e), this.document.addEventListener("touchcancel", this.onDocMouseTouchEnd, e), this.componentRef.addEventListener("medialoaded", this.onMediaLoaded);
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.document.removeEventListener && (this.document.removeEventListener("mousemove", this.onDocMouseTouchMove), this.document.removeEventListener("touchmove", this.onDocMouseTouchMove), this.document.removeEventListener("mouseup", this.onDocMouseTouchEnd), this.document.removeEventListener("touchend", this.onDocMouseTouchEnd), this.document.removeEventListener("touchcancel", this.onDocMouseTouchEnd), this.componentRef.removeEventListener("medialoaded", this.onMediaLoaded));
        }
      }, {
        key: "componentDidUpdate",
        value: function value(e) {
          var t = this.props.crop;

          if (this.imageRef && e.crop !== t && t.aspect && (t.width && !t.height || !t.width && t.height)) {
            var r = this.imageRef,
                n = r.width,
                o = r.height,
                i = R(this.makeNewCrop(), n, o),
                a = _(i, n, o),
                c = E(i, n, o);

            this.props.onChange(a, c), this.props.onComplete(a, c);
          }
        }
      }, {
        key: "createNewCrop",
        value: function value() {
          var e = this.mediaDimensions,
              t = e.width,
              r = e.height,
              n = function (e, t, r) {
            return !e.aspect || e.width && e.height ? e : R(e, t, r);
          }(this.makeNewCrop(), t, r);

          return {
            pixelCrop: _(n, t, r),
            percentCrop: E(n, t, r)
          };
        }
      }, {
        key: "onImageLoad",
        value: function value(e) {
          var t = this.props,
              r = t.onComplete,
              n = t.onChange;

          if (!1 !== (0, t.onImageLoaded)(e)) {
            var o = this.createNewCrop(),
                i = o.pixelCrop,
                a = o.percentCrop;
            n(i, a), r(i, a);
          }
        }
      }, {
        key: "getDocumentOffset",
        value: function value() {
          var e = this.document.documentElement || {},
              t = e.clientTop,
              r = void 0 === t ? 0 : t,
              n = e.clientLeft;
          return {
            clientTop: r,
            clientLeft: void 0 === n ? 0 : n
          };
        }
      }, {
        key: "getWindowOffset",
        value: function value() {
          var e = this.window,
              t = e.pageYOffset,
              r = void 0 === t ? 0 : t,
              n = e.pageXOffset;
          return {
            pageYOffset: r,
            pageXOffset: void 0 === n ? 0 : n
          };
        }
      }, {
        key: "getElementOffset",
        value: function value(e) {
          var t = e.getBoundingClientRect(),
              r = this.getDocumentOffset(),
              n = this.getWindowOffset();
          return {
            top: t.top + n.pageYOffset - r.clientTop,
            left: t.left + n.pageXOffset - r.clientLeft
          };
        }
      }, {
        key: "getCropStyle",
        value: function value() {
          var e = this.makeNewCrop(this.props.crop ? this.props.crop.unit : "px");
          return {
            top: "".concat(e.y).concat(e.unit),
            left: "".concat(e.x).concat(e.unit),
            width: "".concat(e.width).concat(e.unit),
            height: "".concat(e.height).concat(e.unit)
          };
        }
      }, {
        key: "getNewSize",
        value: function value() {
          var e,
              t = this.props,
              r = t.crop,
              n = t.minWidth,
              o = t.maxWidth,
              i = t.minHeight,
              a = t.maxHeight,
              c = this.evData,
              s = this.mediaDimensions,
              d = s.width,
              u = s.height,
              p = c.cropStartWidth + c.xDiff;
          return c.xCrossOver && (p = Math.abs(p)), p = x(p, n, o || d), e = r.aspect ? p / r.aspect : c.cropStartHeight + c.yDiff, c.yCrossOver && (e = Math.min(Math.abs(e), c.cropStartY)), e = x(e, i, a || u), r.aspect && (p = x(e * r.aspect, 0, d)), {
            width: p,
            height: e
          };
        }
      }, {
        key: "dragCrop",
        value: function value() {
          var e = this.makeNewCrop(),
              t = this.evData,
              r = this.mediaDimensions,
              n = r.width,
              o = r.height;
          return e.x = x(t.cropStartX + t.xDiff, 0, n - e.width), e.y = x(t.cropStartY + t.yDiff, 0, o - e.height), e;
        }
      }, {
        key: "resizeCrop",
        value: function value() {
          var e = this.evData,
              t = this.makeNewCrop(),
              r = e.ord;
          e.xInversed && (e.xDiff -= 2 * e.cropStartWidth, e.xDiffPc -= 2 * e.cropStartWidth), e.yInversed && (e.yDiff -= 2 * e.cropStartHeight, e.yDiffPc -= 2 * e.cropStartHeight);
          var n = this.getNewSize(),
              o = e.cropStartX,
              i = e.cropStartY;
          e.xCrossOver && (o = t.x + (t.width - n.width)), e.yCrossOver && (i = !1 === e.lastYCrossover ? t.y - n.height : t.y + (t.height - n.height));
          var c = this.mediaDimensions,
              s = c.width,
              d = c.height,
              u = k(this.props.crop, {
            unit: t.unit,
            x: o,
            y: i,
            width: n.width,
            height: n.height,
            aspect: t.aspect
          }, s, d);
          return t.aspect || a.xyOrds.indexOf(r) > -1 ? (t.x = u.x, t.y = u.y, t.width = u.width, t.height = u.height) : a.xOrds.indexOf(r) > -1 ? (t.x = u.x, t.width = u.width) : a.yOrds.indexOf(r) > -1 && (t.y = u.y, t.height = u.height), e.lastYCrossover = e.yCrossOver, this.crossOverCheck(), t;
        }
      }, {
        key: "straightenYPath",
        value: function value(e) {
          var t,
              r,
              n = this.evData,
              o = n.ord,
              i = n.cropOffset,
              a = n.cropStartWidth,
              c = n.cropStartHeight;
          return "nw" === o || "se" === o ? (t = c / a, r = i.top - i.left * t) : (t = -c / a, r = i.top + (c - i.left * t)), t * e + r;
        }
      }, {
        key: "createCropSelection",
        value: function value() {
          var e = this,
              t = this.props,
              r = t.disabled,
              n = t.locked,
              i = t.renderSelectionAddon,
              a = t.ruleOfThirds,
              c = t.crop,
              s = this.getCropStyle();
          return o.a.createElement("div", {
            ref: function ref(t) {
              return e.cropSelectRef = t;
            },
            style: s,
            className: "ReactCrop__crop-selection",
            onMouseDown: this.onCropMouseTouchDown,
            onTouchStart: this.onCropMouseTouchDown
          }, !r && !n && o.a.createElement("div", {
            className: "ReactCrop__drag-elements"
          }, o.a.createElement("div", {
            className: "ReactCrop__drag-bar ord-n",
            "data-ord": "n"
          }), o.a.createElement("div", {
            className: "ReactCrop__drag-bar ord-e",
            "data-ord": "e"
          }), o.a.createElement("div", {
            className: "ReactCrop__drag-bar ord-s",
            "data-ord": "s"
          }), o.a.createElement("div", {
            className: "ReactCrop__drag-bar ord-w",
            "data-ord": "w"
          }), o.a.createElement("div", {
            className: "ReactCrop__drag-handle ord-nw",
            "data-ord": "nw"
          }), o.a.createElement("div", {
            className: "ReactCrop__drag-handle ord-n",
            "data-ord": "n"
          }), o.a.createElement("div", {
            className: "ReactCrop__drag-handle ord-ne",
            "data-ord": "ne"
          }), o.a.createElement("div", {
            className: "ReactCrop__drag-handle ord-e",
            "data-ord": "e"
          }), o.a.createElement("div", {
            className: "ReactCrop__drag-handle ord-se",
            "data-ord": "se"
          }), o.a.createElement("div", {
            className: "ReactCrop__drag-handle ord-s",
            "data-ord": "s"
          }), o.a.createElement("div", {
            className: "ReactCrop__drag-handle ord-sw",
            "data-ord": "sw"
          }), o.a.createElement("div", {
            className: "ReactCrop__drag-handle ord-w",
            "data-ord": "w"
          })), i && D(c) && o.a.createElement("div", {
            className: "ReactCrop__selection-addon",
            onMouseDown: function onMouseDown(e) {
              return e.stopPropagation();
            }
          }, i(this.state)), a && o.a.createElement(o.a.Fragment, null, o.a.createElement("div", {
            className: "ReactCrop__rule-of-thirds-hz"
          }), o.a.createElement("div", {
            className: "ReactCrop__rule-of-thirds-vt"
          })));
        }
      }, {
        key: "makeNewCrop",
        value: function value() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "px",
              t = y(y({}, a.defaultCrop), this.props.crop),
              r = this.mediaDimensions,
              n = r.width,
              o = r.height;
          return "px" === e ? _(t, n, o) : E(t, n, o);
        }
      }, {
        key: "crossOverCheck",
        value: function value() {
          var e = this.evData,
              t = this.props,
              r = t.minWidth,
              n = t.minHeight;
          !r && (!e.xCrossOver && -Math.abs(e.cropStartWidth) - e.xDiff >= 0 || e.xCrossOver && -Math.abs(e.cropStartWidth) - e.xDiff <= 0) && (e.xCrossOver = !e.xCrossOver), !n && (!e.yCrossOver && -Math.abs(e.cropStartHeight) - e.yDiff >= 0 || e.yCrossOver && -Math.abs(e.cropStartHeight) - e.yDiff <= 0) && (e.yCrossOver = !e.yCrossOver);
          var o = e.xCrossOver !== e.startXCrossOver,
              i = e.yCrossOver !== e.startYCrossOver;
          e.inversedXOrd = !!o && S(e.ord), e.inversedYOrd = !!i && S(e.ord);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this,
              t = this.props,
              r = t.children,
              n = t.circularCrop,
              i = t.className,
              a = t.crossorigin,
              s = t.crop,
              d = t.disabled,
              u = t.locked,
              p = t.imageAlt,
              h = t.onImageError,
              f = t.renderComponent,
              l = t.src,
              m = t.style,
              v = t.imageStyle,
              y = t.ruleOfThirds,
              g = this.state,
              w = g.cropIsActive,
              C = g.newCropIsBeingDrawn,
              b = D(s) && this.componentRef ? this.createCropSelection() : null,
              O = function () {
            for (var e, t, r = 0, n = ""; r < arguments.length;) {
              (e = arguments[r++]) && (t = c(e)) && (n && (n += " "), n += t);
            }

            return n;
          }("ReactCrop", i, {
            "ReactCrop--active": w,
            "ReactCrop--disabled": d,
            "ReactCrop--locked": u,
            "ReactCrop--new-crop": C,
            "ReactCrop--fixed-aspect": s && s.aspect,
            "ReactCrop--circular-crop": s && n,
            "ReactCrop--rule-of-thirds": s && y,
            "ReactCrop--invisible-crop": !this.dragStarted && s && !s.width && !s.height
          });

          return o.a.createElement("div", {
            ref: function ref(t) {
              e.componentRef = t;
            },
            className: O,
            style: m,
            onTouchStart: this.onComponentMouseTouchDown,
            onMouseDown: this.onComponentMouseTouchDown,
            tabIndex: "0",
            onKeyDown: this.onComponentKeyDown,
            onKeyUp: this.onComponentKeyUp
          }, o.a.createElement("div", {
            ref: function ref(t) {
              e.mediaWrapperRef = t;
            }
          }, f || o.a.createElement("img", {
            ref: function ref(t) {
              return e.imageRef = t;
            },
            crossOrigin: a,
            className: "ReactCrop__image",
            style: v,
            src: l,
            onLoad: function onLoad(t) {
              return e.onImageLoad(t.target);
            },
            onError: h,
            alt: p
          })), r, b);
        }
      }, {
        key: "mediaDimensions",
        get: function get() {
          var e = this.mediaWrapperRef;
          return {
            width: e.clientWidth,
            height: e.clientHeight
          };
        }
      }]) && u(t.prototype, r), n && u(t, n), a;
    }(n.PureComponent);

    M.xOrds = ["e", "w"], M.yOrds = ["n", "s"], M.xyOrds = ["nw", "ne", "se", "sw"], M.nudgeStep = 1, M.nudgeStepMedium = 10, M.nudgeStepLarge = 100, M.defaultCrop = {
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      unit: "px"
    }, M.propTypes = {
      className: a.a.string,
      children: a.a.oneOfType([a.a.arrayOf(a.a.node), a.a.node]),
      circularCrop: a.a.bool,
      crop: a.a.shape({
        aspect: a.a.number,
        x: a.a.number,
        y: a.a.number,
        width: a.a.number,
        height: a.a.number,
        unit: a.a.oneOf(["px", "%"])
      }),
      crossorigin: a.a.string,
      disabled: a.a.bool,
      locked: a.a.bool,
      imageAlt: a.a.string,
      imageStyle: a.a.shape({}),
      keepSelection: a.a.bool,
      minWidth: a.a.number,
      minHeight: a.a.number,
      maxWidth: a.a.number,
      maxHeight: a.a.number,
      onChange: a.a.func.isRequired,
      onImageError: a.a.func,
      onComplete: a.a.func,
      onImageLoaded: a.a.func,
      onDragStart: a.a.func,
      onDragEnd: a.a.func,
      src: a.a.string.isRequired,
      style: a.a.shape({}),
      renderComponent: a.a.node,
      renderSelectionAddon: a.a.func,
      ruleOfThirds: a.a.bool
    }, M.defaultProps = {
      circularCrop: !1,
      className: void 0,
      crop: void 0,
      crossorigin: void 0,
      disabled: !1,
      locked: !1,
      imageAlt: "",
      maxWidth: void 0,
      maxHeight: void 0,
      minWidth: 0,
      minHeight: 0,
      keepSelection: !1,
      onComplete: function onComplete() {},
      onImageError: function onImageError() {},
      onImageLoaded: function onImageLoaded() {},
      onDragStart: function onDragStart() {},
      onDragEnd: function onDragEnd() {},
      children: void 0,
      style: void 0,
      renderComponent: void 0,
      imageStyle: void 0,
      renderSelectionAddon: void 0,
      ruleOfThirds: !1
    };
  }]);
});